import { Component, Input, OnInit } from '@angular/core';
import { Options } from '@angular-slider/ngx-slider';
import pdfMake from 'pdfmake/build/pdfmake';
import domtoimage from 'dom-to-image';
import { MeasureService } from 'src/app/modules/measure/measure.service';
import { DateTimePipe } from 'src/app/shared/pipe/date.pipe';
import { map } from 'rxjs/operators';
import { whiteSpace } from 'src/assets/white-space';

@Component({
  selector: 'lifedi-matching-informant',
  templateUrl: './matching-informant.component.html',
  styleUrls: ['./matching-informant.component.scss']
})
export class MatchingInformantComponent implements OnInit {
  @Input() measureid: string;
  @Input() type: string;
  @Input() view_status: number;
  @Input() access_id: string;
  @Input() informant_type: string;
  data_report;

  value: number = 10;
  highValue: number = 50;
  options: Options[] = [];

  isLoading: boolean = false;

  constructor(private measureService: MeasureService) { }

  ngOnInit(): void {
    this.isLoading = true;
    let body;
    if (this.access_id) {
      body = {
        MEASURE_ID: this.measureid,
        TYPE_REPORT: this.type,
        ACCESS_ID: this.access_id,
        INFORMANT_TYPE: this.informant_type,
      };
    } else {
      body = {
        MEASURE_ID: this.measureid,
        TYPE_REPORT: this.type,
        INFORMANT_TYPE: this.informant_type,
      };
    }

    this.getReport(body);
  }

  getReport(body) {
    this.measureService.getReportByMeasureId(body).pipe(
      map(async (res) => {
        this.data_report = res.result;
        // console.log(this.data_report);
        for (let i = 0; i < this.data_report.data.length; i++) {
          for (
            let j = 0;
            j < this.data_report.data[i].ideal_data.length;
            j++
          ) {
            this.options.push({
              floor: +this.data_report.data[i].ideal_data[j].min,
              ceil: +this.data_report.data[i].ideal_data[j].max,
              disabled: true,
            });
          }
        }

        setTimeout(() => {
          this.filepdf('email');
        }, 1000);
        this.isLoading = false;
      })
    ).subscribe();
  }

  filepdf(transfer) {
    let formattedDate = new DateTimePipe().transform(
      this.data_report.done_measure_date.toString(),
      'FullNoTime'
    );
    let userid = this.data_report.user_id;
    let alldata = this.data_report;
    let allPage;
    let matchingChart = [];
    let matchingInformant = [];

    let num_slider = this.data_report.data[0].ideal_data.length;
    let num_slider1 = this.data_report.data2[0].ideal_data.length;

    for (let i = 0; i < alldata.data.length; i++) {
      for (let j = 0; j < alldata.data[i].ideal_data.length; j++) {
        let a = document.getElementById(
          'sliderpdf' + alldata.data[i].ideal_data[j].id
        );
        matchingChart.push(a);
      }
    }

    for (let i = 0; i < alldata.data2.length; i++) {
      for (let j = 0; j < alldata.data2[i].ideal_data.length; j++) {
        let b = document.getElementById(
          'sliderpdfInformant' + alldata.data2[i].ideal_data[j].id
        );
        matchingInformant.push(b);
      }
    }
    // console.log(matchingChart);

    Promise.all([...matchingChart, ...matchingInformant].map((node) => domtoimage.toPng(node))).then(
      (dataArray) => {
        let halfIndex = Math.ceil(dataArray.length / 2);
        let matchChart = dataArray.slice(0, halfIndex);
        let matchInf = dataArray.slice(halfIndex);
        console.log(matchChart, matchInf);
        console.log(dataArray);

        pdfMake.fonts = {
          THsarabunNew: {
            normal: 'THSarabun.ttf',
            bold: 'THSarabunNew Bold.ttf',
            italics: 'THSarabunNew Italic.ttf',
            bolditalics: 'THSarabunNew BoldItalic.ttf',
          },
        };

        allPage = {
          pageSize: 'A4',
          pageOrientation: 'portrait',
          header: function (currentPage) {
            return [
              {
                text:
                  userid +
                  ' | ' +
                  formattedDate +
                  ' หน้า ' +
                  currentPage.toString(),
                width: '*',
                alignment: 'right',
                margin: [40, 20],
              },
            ];
          },
          content: [
            {
              text: this.data_report.reportname,
              alignment: 'center',
              fontSize: 24,
              color: '#060e9f',
              margin: [0, 10],
              bold: true,
            },
            {
              text: this.data_report.measure_name,
              alignment: 'left',
              fontSize: 22,
              decoration: 'underline',
              margin: [0, 10],
              bold: true,
            },
            {
              text: this.data_report.report_description,
              width: '*',
              fontSize: 16,
              margin: [0, 0, 0, 15],
            },
            {
              table: {
                headerRows: 1,
                widths: [100],
                heights: [-4],
                body: [
                  [
                    {
                      text: 'ผู้ทำแบบทดสอบ',
                      fontSize: 13,
                      bold: true,
                      aligment: 'center',
                      fillColor: '#060e9f',
                      border: [true, true, true, true],
                      color: '#ffffff',
                      alignment: 'center',
                      margin: [0, 0],
                      borderColor: ['#060e9f', '#060e9f', '#060e9f', '#060e9f'],
                    }
                  ]
                ]
              }
            },
          ],
          defaultStyle: {
            font: 'THsarabunNew',
          },
        };
        for (let i = 0; i < alldata.data.length; i++) {
          allPage.content.push({
            text: this.data_report.data[i].ideal_type,
            alignment: 'center',
            fontSize: 22,
            decoration: 'underline',
            color: '#000000',
            margin: [0, 10],
            bold: true,
            pageBreak: '',
          });
          for (let j = 0; j < alldata.data[i].ideal_data.length; j++) {
            allPage.content.push({
              columns: [
                {
                  text: this.data_report.data[i].ideal_data[j].psy_name,
                  alignment: 'left',
                  fontSize: 14,
                  decoration: 'underline',
                  color: '#060e9f',
                  margin: [0, 10, 20, 0],
                  bold: true,
                  width: 150,
                },
                {
                  image: matchChart[j],
                  width: 220,
                  height: 50,
                  alignment: 'center',
                  margin: [0, 15, 0, 0],
                },
                [
                  {
                    text:
                      'ท่านได้ ' +
                      parseFloat(this.data_report.data[i].ideal_data[j].value).toFixed(2) +
                      ' คะแนน',
                    fontSize: 14,
                    color: '#060e9f',
                    margin: [20, 5, 0, 0],
                    bold: true,
                  },
                  {
                    text:
                      'คะแนนที่เหมาะสม ' +
                      this.data_report.data[i].ideal_data[j].ideal_value +
                      ' คะแนน',
                    fontSize: 14,
                    color: '#ffc90e',
                    margin: [20, 5, 0, 0],
                    bold: true,
                  },
                ],
              ],
              // columnGap: 5,
            });
            num_slider++;
          }
        }
        for (let i = 0; i < alldata.data.length; i++) {
          allPage.content.push({
            text: this.data_report.data[i].ideal_type,
            alignment: 'center',
            fontSize: 22,
            color: '#000000',
            decoration: 'underline',
            margin: [0, 10],
            bold: true,
            pageBreak: 'before',
          });
          for (let j = 0; j < alldata.data[i].ideal_data.length; j++) {
            allPage.content.push(
              {
                text: this.data_report.data[i].ideal_data[j].psy_name,
                alignment: 'left',
                fontSize: 18,
                decoration: 'underline',
                color: '#060e9f',
                margin: [0, 20, 0, 0],
                bold: true,
              },
              {
                text: this.data_report.data[i].ideal_data[j].psy_description,
                alignment: 'left',
                fontSize: 14,
                decoration: '',
                color: '#000000',
                margin: [0, 10, 0, 0],
                pageBreak: '',
                bold: false,
              },
              {
                text:
                  'คะแนนต่ำสุด : ' +
                  this.data_report.data[i].ideal_data[j].min +
                  '    คะแนนสูงสุด : ' +
                  this.data_report.data[i].ideal_data[j].max,
                alignment: 'left',
                fontSize: 18,
                color: '#000000',
                margin: [0, 10, 0, 0],
                bold: true,
              },
              {
                text:
                  'ท่านได้ ' +
                  parseFloat(this.data_report.data[i].ideal_data[j].value).toFixed(2) +
                  ' คะแนน',
                // ' อยู่ในช่วงคะแนน ' +
                // this.data_report.data[i].ideal_data[j].range +
                // ' คะแนน',
                alignment: 'left',
                fontSize: 18,
                color: '#060e9f',
                margin: [0, 5, 0, 0],
                bold: true,
              },
              {
                text: this.data_report.data[i].ideal_data[j]
                  .range_description,
                alignment: 'left',
                fontSize: 14,
                color: '#000000',
                margin: [0, 10, 0, 10],
                bold: false,
              },
              {
                text: '_____________________________________________________________________________________________',
                alignment: 'center',
                fontSize: 10,
                color: 'gray',
                margin: [0, 10, 0, 30],
                bold: false,
              }
            );
          }
        }

        let parances = [];
        this.data_report.parances.forEach(e => {
          parances.push(`${e.EMAIL} (${e.TAG})`)
        });
        let parancesStr = (parances.join()).replace(/,/g, ', ')

        allPage.content.push(
          {
            image: whiteSpace, // ใส่กรณีที่ text ใส่ pageBreak ไม่ได้
            width: 300,
            alignment: 'center',
            margin: [0, 0],
            pageBreak: 'before',
          },
          {
            text: '',
            width: '*',
            fontSize: 14,
            margin: [0, 0, 0, 5],
          },
          {
            table: {
              headerRows: 1,
              widths: [120],
              heights: [-5],
              body: [
                [
                  {
                    text: 'ผู้มีส่วนร่วมในแบบทดสอบนี้',
                    fontSize: 15,
                    bold: true,
                    aligment: 'center',
                    fillColor: '#060e9f',
                    border: [true, true, true, true],
                    color: '#ffffff',
                    alignment: 'center',
                    margin: [0, 0],
                    borderColor: ['#060e9f', '#060e9f', '#060e9f', '#060e9f'],
                  }
                ]
              ]
            }
          },
          {
            text: 'รายงานผลของผู้มีส่วนร่วมนี้เป็นของ',
            alignment: 'left',
            fontSize: 16,
            color: '#000',
            margin: [0, 10, 0, 8],
            bold: true,
          },
          {
            text: parancesStr,
            width: '*',
            fontSize: 15,
            margin: [0, 0, 0, 25],
          },
        )

        for (let i = 0; i < alldata.data2.length; i++) {
          allPage.content.push({
            text: this.data_report.data2[i].ideal_type,
            alignment: 'center',
            fontSize: 22,
            decoration: 'underline',
            color: '#000000',
            margin: [0, 10],
            bold: true,
            pageBreak: '',
          });
          for (let j = 0; j < alldata.data2[i].ideal_data.length; j++) {
            allPage.content.push({
              columns: [
                {
                  text: this.data_report.data2[i].ideal_data[j].psy_name,
                  alignment: 'left',
                  fontSize: 14,
                  decoration: 'underline',
                  color: '#060e9f',
                  margin: [0, 10, 20, 0],
                  bold: true,
                  width: 150,
                },
                {
                  image: matchInf[j],
                  width: 220,
                  height: 50,
                  alignment: 'center',
                  margin: [0, 15, 0, 0],
                },
                [
                  {
                    text:
                      'ท่านได้ ' +
                      parseFloat(this.data_report.data2[i].ideal_data[j].value).toFixed(2) +
                      ' คะแนน',
                    fontSize: 14,
                    color: '#060e9f',
                    margin: [20, 5, 0, 0],
                    bold: true,
                  },
                  {
                    text:
                      'คะแนนที่เหมาะสม ' +
                      this.data_report.data2[i].ideal_data[j].ideal_value +
                      ' คะแนน',
                    fontSize: 14,
                    color: '#ffc90e',
                    margin: [20, 5, 0, 0],
                    bold: true,
                  },
                ],
              ],
              // columnGap: 5,
            });
            num_slider1++;
          }
        }
        for (let i = 0; i < alldata.data2.length; i++) {
          allPage.content.push({
            text: this.data_report.data2[i].ideal_type,
            alignment: 'center',
            fontSize: 22,
            color: '#000000',
            decoration: 'underline',
            margin: [0, 10],
            bold: true,
            pageBreak: 'before',
          });
          for (let j = 0; j < alldata.data2[i].ideal_data.length; j++) {
            allPage.content.push(
              {
                text: this.data_report.data2[i].ideal_data[j].psy_name,
                alignment: 'left',
                fontSize: 18,
                decoration: 'underline',
                color: '#060e9f',
                margin: [0, 20, 0, 0],
                bold: true,
              },
              {
                text: this.data_report.data2[i].ideal_data[j].psy_description,
                alignment: 'left',
                fontSize: 14,
                decoration: '',
                color: '#000000',
                margin: [0, 10, 0, 0],
                pageBreak: '',
                bold: false,
              },
              {
                text:
                  'คะแนนต่ำสุด : ' +
                  this.data_report.data2[i].ideal_data[j].min +
                  '    คะแนนสูงสุด : ' +
                  this.data_report.data2[i].ideal_data[j].max,
                alignment: 'left',
                fontSize: 18,
                color: '#000000',
                margin: [0, 10, 0, 0],
                bold: true,
              },
              {
                text:
                  'ท่านได้ ' +
                  parseFloat(this.data_report.data2[i].ideal_data[j].value).toFixed(2) +
                  ' คะแนน',
                // ' อยู่ในช่วงคะแนน ' +
                // this.data_report.data2[i].ideal_data[j].range +
                // ' คะแนน',
                alignment: 'left',
                fontSize: 18,
                color: '#060e9f',
                margin: [0, 5, 0, 0],
                bold: true,
              },
              {
                text: this.data_report.data2[i].ideal_data[j]
                  .range_description,
                alignment: 'left',
                fontSize: 14,
                color: '#000000',
                margin: [0, 10, 0, 10],
                bold: false,
              },
              {
                text: '_____________________________________________________________________________________________',
                alignment: 'center',
                fontSize: 10,
                color: 'gray',
                margin: [0, 10, 0, 30],
                bold: false,
              }
            );
          }
        }

        if (transfer === 'email') {
          let pdfDocGenerator = pdfMake.createPdf(allPage);
          pdfDocGenerator.getBase64((base64str) => {
            // console.log(base64str);
            let data = {
              MEASURE_ID: this.measureid,
              TYPE: this.type,
              base64str: base64str,
              view: this.view_status,
            };
            this.measureService.SaveReportMeasureId(data).subscribe((res) => {
              // console.log(res);
            });
          });
        } else if (transfer === 'download') {
          pdfMake.createPdf(allPage).open();
        }
      }
    );
  }

}
